import type { Fallacy } from "./types";
import { createStory } from "./types";

export const strawMan: Fallacy = {
    id: "straw-man",
    name: "Straw Man",
    emoji: "🥊",
    category: "Menyerang Lawan",
    description:
      "**Mendistorsi argumen lawan** menjadi versi yang lebih mudah diserang, lalu menyerang **versi distorsi itu**.",
    detail:
      "Straw Man adalah taktik debat di mana seseorang sengaja **mengubah atau melebih-lebihkan argumen lawan** menjadi versi yang lebih mudah diserang. Namanya berasal dari analogi: bikin **boneka jerami yang gampang dirobohkan**, lalu pura-pura menang.\n\nPola umumnya:\n1. A menyampaikan argumen X\n2. B mengubah argumen X menjadi Y (versi ekstrem/distorsi)\n3. B menyerang argumen Y\n4. B merasa sudah memenangkan debat\n\nCara melawan: Tegaskan kembali argumen asli kamu. \"Bukan itu yang saya bilang. Yang saya bilang adalah...\"",
    tldr: "Argumen gue didistorsi terus diserang? Klasik Straw Man.",
    story: createStory("Straw Man", "🥊", {
      hook: {
        title: "Kamu bilang A, tapi lawan kamu ngebales seolah kamu bilang Z.",
        body: "Argumen kamu **didistorsi** jadi versi yang gampang diserang. Kamu bahkan gak bilang gitu!",
      },
      convo: {
        claim: "Oh jadi kamu mau **semua pabrik ditutup dan jutaan orang nganggur?** Gitu aja solusinya?",
        response: "Bukan itu yang dibilang. Yang diusulkan cuma **batasi plastik sekali pakai secara bertahap.**",
      },
      reveal: {
        body: "Lawan kamu bikin **boneka jerami** dari argumen kamu — versi yang lebay dan gampang dirobohkan. Terus pura-pura menang.",
      },
      insight: {
        title: "Cara ngadepin?",
        body: "Jangan ikut main di lapangan mereka. Balikin ke argumen asli: **\"Bukan itu yang aku bilang.\"**",
      },
      engagement: {
        title: "Pernah argumen kamu dipelintir kayak gini?",
        body: "Di debat online atau diskusi sama bos? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["ad-hominem", "red-herring", "false-dilemma"],
  };
